import topTypePopup from './top-type-popup'

export default {
    topTypePopup,
}